<template>
  <div>
    componente evento popover
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>